import React, { useEffect, useState } from 'react';

export default function useLastEffect(
  effect: () => boolean,
  deps?: React.DependencyList | undefined,
): void {
  const [internalValue, setInternalValue] = useState(0);
  useEffect((): void => {
    // force rerender only if effect returns true
    if (effect()) {
      setInternalValue(internalValue + 1);
    }
    // this is a util function that will take other deps for useEffect
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [effect, internalValue, setInternalValue, ...(deps || [])]);
}
